import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["file", "image", "placeholder"]

  disconnect() {
    this.#revokePreview()
  }

  show() {
    const file = this.fileTarget.files[0]
    if (!file) return

    this.#revokePreview()
    this.previewObjectUrl = URL.createObjectURL(file)
    this.imageTarget.src = this.previewObjectUrl
    this.imageTarget.hidden = false
    this.placeholderTarget.hidden = true
  }

  #revokePreview() {
    if (!this.previewObjectUrl) return

    URL.revokeObjectURL(this.previewObjectUrl)
    this.previewObjectUrl = null
  }
}
